<template>
  <div class="shipment_ocean">
    <div class="row __centerblock">
      <div class="col text-center">
        <h3 class="text-center __titleGlobal">Select Shipment Type</h3>
        <div class="__tabscontainer">
          <div class="row justify-content-center __tabs">
            <a
              v-on:click="chooseOcean(1)"
              v-bind:class="[ SOactivetab === 1 ? '__activeFCL' : '' ]">
              Full Containers (FCL)
            </a>
            <a
              v-on:click="chooseOcean(2)"
              v-bind:class="[ SOactivetab === 2 ? '__activeFCL' : '' ]">
              Less than a Containers (LCL)
            </a>
          </div>
          <div class="__content">
            <div
              v-if="SOactivetab === 1"
              class="form-container"
            >
              <!-- start fcl component -->
              <FCL
              @IntantPriceData="pushData"
              @errorInput="errorInput"
              :showError="showError"
               />
              <!-- end fcl component -->
            </div>
            <div
              v-if="SOactivetab === 2"
              class="form-container"
            >
              <!-- start lcl component -->
              <LCL
              @IntantPriceData="pushData"
              @errorInput="errorInput"
              :showError="showError"
              />
              <!-- end lcl component -->
            </div>
          </div>
        </div>
      </div>
    </div><!-- end __centerblock -->
  </div>
</template>

<script>
import LCL from './ShipmentType/LCL'
import FCL from './ShipmentType/FCL'

export default {
  name: 'ShipmentOcean',
  props: {
    showError: Boolean
  },
  components: {
    LCL,
    FCL
  },
  data () {
    return {
      SOactivetab: 1,
      header: {
        id: 2,
        subtitle: 'FCL'
      }
    }
  },
  methods: {
    chooseOcean (type) {
      this.SOactivetab = type
      let oceanType = type === 1 ? 'FCL' : 'LCL'

      this.$emit('IntantPriceShipmentType', oceanType)
      this.$emit('IntantPriceData', { shipmentLoad: oceanType.toLowerCase() })
    },
    pushData (payload) {
      this.$emit('IntantPriceData', payload)
    },
    errorInput (payload) {
      this.$emit('errorInput', payload)
    }
  },
  mounted () {
    this.$emit('IntantPriceShipmentType', this.header.subtitle)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/instantPrice/ShipmentOcean.vue